import { render, staticRenderFns } from "./BasicBanner.vue?vue&type=template&id=3130db84&scoped=true"
import script from "./BasicBanner.vue?vue&type=script&lang=js"
export * from "./BasicBanner.vue?vue&type=script&lang=js"
import style0 from "./BasicBanner.vue?vue&type=style&index=0&id=3130db84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130db84",
  null
  
)

export default component.exports